export default __webpack_public_path__ + "static/media/30-Develop-a-Playbook.a749b078.jpg";